import { useEffect, useRef } from 'react'
import { rootStore } from 'stores'

export function useRefetchOnFocus() {
  const { messageStore, notificationStore, authStore } = rootStore
  const lastVisibleTimeRef = useRef<number>(Date.now())

  useEffect(() => {

    const handleVisibilityChange = () => {
      if (!authStore?.userDetail?.id) {
        return
      }

      if (document.visibilityState === 'visible') {
        const now = Date.now()
        const timeSinceLastVisible = now - lastVisibleTimeRef.current

        // Only refetch if tab has been hidden for at least 1 minute (60000ms)
        if (timeSinceLastVisible > 60000) {
          // Refetch notifications
          notificationStore.fetchNotifications()
          notificationStore.aggregateCountNotifications()

          // Refetch messages based on current page
          const currentPath = window.location.pathname
          if (currentPath.includes('/messages')) {
            // Refetch current thread messages
            if (messageStore.currentGeneralThreadId) {
              messageStore.getMessages()
            }
            if (messageStore.currentSupportThreadId) {
              messageStore.getSupportMessages()
              messageStore.getThreadDetail()
            }

            // Refetch threads
            messageStore.fetchGeneralMessageThreads(20, messageStore.generaltMessageKeyword, false)
            messageStore.getSupportMessageThreads(20, false)
            messageStore.getUnreadThread()
          }

          lastVisibleTimeRef.current = now
        } else {
        }
      } else {
        lastVisibleTimeRef.current = Date.now()
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [messageStore, notificationStore, authStore])
} 